/**
 * Скрипт отвечает за обработку нажатия на кнопку оплаты биткоинами таким образом, чтобы следующая страница имела заполненные поля
 * Created by PersonalityFox on 08.08.2017.
 */
window.addEventListener('DOMContentLoaded', DOMReady );

var userInputList;

function DOMReady()
{
	userInputList = document.querySelectorAll( 'li.email input[type="text"],li.email input[type="email"],li.email input[type="password"]' );
	
	// Вешаем слушатель на ввод текста в инпуты
	Array.prototype.forEach.call(
		userInputList,
		function ( input )
		{
			input.addEventListener( 'input', inputUserChangeListener.bind(this) );
		}
	);
}

function inputUserChangeListener( e )
{
	localStorage.setItem( e.currentTarget.className, e.currentTarget.value );
}